import { OnDestroy, OnInit, Type } from '@angular/core';
import { addFillFormListener } from '@wz-utilities/window.utilities';

export const DEV_SETTINGS_KEY = 'DEV_SETTINGS';

const FILLERS_KEY = '__FILLERS_KEY';
export function AutoFillable<T extends Type<OnDestroy> & Type<OnInit>>() {
  return function (target: T) {
    if (target.prototype.hasOwnProperty(FILLERS_KEY)) {
      const originalOnDestroy = target.prototype.ngOnDestroy;
      const originalOnInit = target.prototype.ngOnInit;

      // Replace with our ngOnInit
      target.prototype.ngOnInit = function () {
        this.__removeFillFormListener = addFillFormListener(() => {
          const devSettingsRaw = localStorage.getItem(DEV_SETTINGS_KEY);
          const devSettings: DevSettings = devSettingsRaw
            ? JSON.parse(devSettingsRaw)
            : null;
          if (devSettings && devSettings.autoFill) {
            this[FILLERS_KEY].forEach((methodName: any) => {
              this[methodName].apply(this, [devSettings]);
            });
          }
        });

        // Apply original ngOnDestroy
        if (originalOnInit && typeof originalOnInit === 'function') {
          originalOnInit.apply(this, arguments);
        }
      };

      // Replace with our ngOnDestroy
      target.prototype.ngOnDestroy = function () {
        this.__removeFillFormListener();

        // Apply original ngOnDestroy
        if (originalOnDestroy && typeof originalOnDestroy === 'function') {
          originalOnDestroy.apply(this, arguments);
        }
      };
    }
  };
}

export function AutoFiller() {
  return (
    target: object | any,
    methodName: string,
    descriptor: TypedPropertyDescriptor<any>,
  ) => {
    const originalMethod: any = descriptor.value;

    if (target.hasOwnProperty(FILLERS_KEY)) {
      target[FILLERS_KEY].push(methodName);
    } else {
      target[FILLERS_KEY] = [methodName];
    }
    descriptor.value = function (...args: any[]) {
      return originalMethod.apply(this, args);
    };
  };
}

export interface DevSettings {
  autoFill: boolean;
  mobile: string;
  email: string;
  debug: boolean;
}
